import { Action, createReducer, on } from '@ngrx/store';

import {
  BillingBookingDocuments, BookingBillingTypeDocumentProps, BookingPaxTypeDocumentProps,
  DocumentAssetState, PaxBookingDocuments
} from '@app/entities/booking-documents';
import { AssetBookingDocuments } from '@asset-booking-documents';
import * as bookingActions from '@booking/store/actions/booking.actions';
import { ValidDocumentsResponse } from '@booking/entities/hotel-validation.response';

export const initialDocumentState: DocumentAssetState = AssetBookingDocuments as DocumentAssetState;

const featureReducer = createReducer(
  initialDocumentState,
  on(bookingActions.resetValidatorsAction, () => initialDocumentState),
  on(
    bookingActions.fetchAirValidationSuccessAction,
    bookingActions.fetchAirValidationBySectorSuccessAction,
    bookingActions.fetchHotelValidationSuccessAction,
    bookingActions.fetchAutoValidationSuccessAction,
    bookingActions.fetchPackageValidationSuccessAction,
    (state, { response }) => {
      const { ValidDocuments } = response;
      return state && Object.keys(state).length && ValidDocuments ?
        getState(ValidDocuments, state) : initialDocumentState;
    }
  )
);

function getState(
  validDocuments: ValidDocumentsResponse[], state: DocumentAssetState
): DocumentAssetState {
  const paxState = getValidPaxDocumentState(validDocuments, state);
  const billingState = getValidBillingDocumentState(state);
  return {
    BOOKING_GENERAL_CONFIG: state?.BOOKING_GENERAL_CONFIG,
    BOOKING_MODULES_BUSINESS_RULES: state?.BOOKING_MODULES_BUSINESS_RULES,
    PAX: paxState,
    BILLING: billingState,
  };
}

function getValidPaxDocumentState(
  validDocuments: ValidDocumentsResponse[], state: DocumentAssetState
): PaxBookingDocuments {
  const paxValidDocuments = {};
  const paxState = state?.PAX;
  for (const travelerType in paxState) {
    if (Object.hasOwnProperty.call(paxState, travelerType)) {
      const documents = paxState[travelerType] as BookingPaxTypeDocumentProps[];
      paxValidDocuments[travelerType] = documents
        .filter(paxDocument => {
          const isDisabled = !!paxDocument.VALIDATIONS?.IS_DISABLED;
          return !state?.BOOKING_GENERAL_CONFIG?.DISABLED_BOOKING_VALIDATE_SERVICES_BY_FILTER_DOCUMENTS ?
            !isDisabled && validDocuments.some(validDocument => validDocument.Id === paxDocument.DOCUMENT_ID) :
            !isDisabled;
        });
    }
  }
  return paxValidDocuments as PaxBookingDocuments;
}

function getValidBillingDocumentState(state: DocumentAssetState): BillingBookingDocuments {
  const billingValidDocuments = {};
  const billingState = state?.BILLING;
  for (const billingPersonType in billingState) {
    if (Object.hasOwnProperty.call(billingState, billingPersonType)) {
      const documents = billingState[billingPersonType] as BookingBillingTypeDocumentProps[];
      billingValidDocuments[billingPersonType] = documents
        .filter(billingDocument => !billingDocument.VALIDATIONS?.IS_DISABLED);
    }
  }
  return billingValidDocuments as BillingBookingDocuments;
}

export const documentAssetsReducer = (state: DocumentAssetState, action: Action): DocumentAssetState => {
  return featureReducer(state, action);
};
